<template>
  <div name="stdapplinf-detail-pg5">
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['110'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['30'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.adrreg1 }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['130'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codsubdistr }} - {{ data.ti_descodistr }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['50'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.coddistr }} - {{ data.ti_descodamphr }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['150'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codprovr }} - {{ data.ti_codprovr }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['70'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codcntyi }} - {{ data.ti_descntyi }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['90'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codposte }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card-ui clearfix border-top-color-skin">
          <div class="sub-topic-box clearfix" style="cursor: auto;">
            <div class="sub-topic">{{ labels['20'] }}</div>
          </div>

          <div class="data-box clearfix">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['120'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.adrcont1 }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['40'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codsubdistc }} - {{ data.ti_descodistc }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['140'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.coddistc }} - {{ data.ti_descodamphc }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['60'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codprovc }} - {{ data.ti_codprovc }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['160'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codcntyc }} - {{ data.ti_descntyc }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['170'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.codpostc }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['80'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.numtelem }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['180'] }}</label>
                  <div class="form-control readonly-field-color">{{ data.email }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stdapplinf-detail-pg5',
  props: [ 'labels', 'data' ]
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg5.vue?19d885a8